module.exports = __webpack_public_path__ + "img/circleWhiteUser.png?30260aa8f086e311f5c49e67776f0f82";